export default {
  data() {
    return {};
  },
  methods: {},
  created() {},
};
